<template >
  <div
    v-if="
      lesson != null && lesson.deleted != undefined && lesson.deleted == true
    "
    class="container"
    style="marting-top: 100px !important"
  >
    <div class="row justify-content-center align-self-center">
      <div class="alert alert-warning" style="display: block" role="alert">
        <h1>Xичээл устгагдсан байна!</h1>
      </div>
    </div>
  </div>
  <div class="container-fluid" v-else>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <!-- <h3 class="text-center">{{school.name}}</h3> -->

        <div class="row" style="margin-bottom: 40px">
          <div class="col">
            <button
              type="button"
              class="btn btn-danger btn-block"
              style="
                background-color: #1967d2;
                box-shadow: #ed3d63 0px 1px 2px 0px,
                  rgba(25, 103, 210, 0.15) 0px 2px 6px 2px;
              "
              @click="_addTopic"
            >
              <span style="font-weight: 500; letter-spacing: 0.25px"
                >Сэдэв
              </span>

              <svg
                focusable="false"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: currentColor; flex-shrink: 0"
              >
                <path d="M20 13h-7v7h-2v-7H4v-2h7V4h2v7h7v2z"></path>
              </svg>
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary btn-block"
              @click="
                $router.push({
                  name: 'ILessonScoresDaalgavar',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Даалгавар
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-mygray btn-block"
              @click="
                $router.push({
                  name: 'ILessonGroup',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Ангиуд
            </button>
          </div>
<!-- 
          <div class="col">
            <button
              type="button"
              class="btn btn-mygray btn-block"
              @click="
                $router.push({
                  name: 'ILessonSchedule',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Хуваарь
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-mygray btn-block"
              @click="
                $router.push({
                  name: 'ILessonLog',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Ирц бүртгэл
            </button>
          </div> -->

          <div class="col">
            <button
              type="button"
              class="btn btn-mygray btn-block"
              @click="
                $router.push({
                  name: 'ILessonScores',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Явцын дүн
            </button>
          </div>
          <!-- <div class="col">
            <button
              type="button"
              class="btn btn-danger btn-block"
              @click="
                $router.push({
                  name: 'ILessonScoresAyear',
                  params: { schoolId: schoolId, lessonId: lesson.id },
                })
              "
            >
              Жилийн дүн
            </button>
          </div> -->

          <!-- <div class="col">
        <button type="button" class="btn btn-info btn-block btn-lg" @click="$router.push({name:'ILessonStats', params: {schoolId:schoolId, lessonId: lesson.id}   })">
          Үзүүлэлт
        </button>
      </div>
      <div class="col">
        <button type="button" class="btn btn-info btn-block btn-lg" @click="$router.push({name:'ILessonAssignment', params: {schoolId:schoolId, lessonId: lesson.id}   })">
          Даалгавар
        </button>
      </div> -->
        </div>
        <p v-if="runningSemester">{{ runningSemester.name }}</p>
        <hr />

        <div v-if="school">
          <topics
            v-if="topics && topics.length > 0"
            :_editTopic="_editTopic"
            :topics="topics"
            :lesson="lesson"
            :schoolId="schoolId"
            :types="types"
            :lessonId="lesson.id"
          ></topics>
          <div v-else class="alert alert-warning text-center mb-4">
            <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
          </div>
        </div>
        <hr class="mb-5" />

        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Сэдэв нэмэх</h5>

                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form class="user">
                  <div class="form-group">
                    <label>Сэдвийн нэр</label>
                    <input
                      v-model.trim="topic.name"
                      class="form-control"
                      id="exampleInputEmail"
                      aria-describedby="emailHelp"
                      placeholder="Сэдвийн нэр"
                    />
                  </div>
                  <div class="form-group">
                    <label>Товч нэр</label>
                    <input
                      v-model.trim="topic.shortname"
                      class="form-control"
                      placeholder="Товч нэр /2018, 2019/"
                    />
                  </div>
                  <div class="form-group">
                    <label>Сэдвийн дэлгэрэнгүй</label>
                    <textarea
                      rows="5"
                      v-model.trim="topic.description"
                      class="form-control"
                      id="exampleInputPassword"
                      placeholder="Сэдвийн дэлгэрэнгүй"
                    />
                  </div>
                  <!-- <div class="form-group">
                  <label>Сэдвийн үнэ: </label>
                  <input v-model.number="topic.price" class="form-control" placeholder="Сэдвийн үнэ" type="number">
                </div> -->
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="exampleCheck1"
                      v-model="topic.published"
                    />
                    <label class="form-check-label" for="exampleCheck1">
                      Бүх сурагчдад нээлттэй болгох
                      <span class="text-primary"
                        >/Энэ сэдэв тухайн ангид орсоноос үл хамааран энэ
                        контентийг сурагчдад үзүүлэх/</span
                      >
                    </label>
                  </div>
                  <div class="form-group">
                    <label>Түлхүүр үгс</label>
                    <div class="row">
                      <div class="col">
                        <input
                          v-model.trim="tagText"
                          v-on:keyup.enter="addTag(tagText)"
                          type="text"
                          class="form-control"
                          placeholder="тригонометр, функц"
                        />
                      </div>
                      <div class="col">
                        <button
                          type="button"
                          @click="addTag(tagText)"
                          class="btn btn-mygray btn-sm"
                        >
                          Түлхүүр үг нэмэх
                        </button>
                      </div>
                    </div>
                    <div>
                      <span
                        class="badge badge-pill badge-success mr-2"
                        v-for="(tag, ti) in topic.tags"
                        :key="ti"
                      >
                        {{ tag }}
                        <i
                          class="fas fa-times ml-2"
                          style="cursor: pointer"
                          @click="removeTag(tag, ti)"
                        ></i>
                      </span>
                    </div>
                  </div>

                  <hr />
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Цуцлаx
                </button>
                <button
                  @click="saveTopic"
                  type="button"
                  class="btn btn-primary btn-user btn-block"
                >
                  Xадгалаx
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <lesson-info
          v-if="lesson != null"
          :lesson="lesson"
          :schoolId="schoolId"
          :edit="true"
          :showDetail="true"
        ></lesson-info>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import Topics from "./Topics"; //README
import LessonInfo from "../shared/LessonInfo";
export default {
  name: "XILessonDetail",

  data() {
    return {
      lesson: null,
      topic: {
        name: null,
        description: null,
        price: 0,
        tags: [],
        shortname: null,
      },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],
      tmpAdditionalFile: {
        name: "",
        uploading: false,
        uploadPercent: null,
      },
      lessonBucket: "lessonFiles/",
      topicBucket: "lessonTopicFiles/",
      tagText: null,
      school: null,
      semesters: [],
      selectedSemester: null,
      runningSemester: null,
    };
  },
  methods: {
    async _setupp() {
      var sem = await fb.db
        .collection("schools/" + this.schoolId + "/semester")
        .where("running", "==", true)
        .limit(1)
        .get();

      if (!sem.empty) {
        this.runningSemester = sem.docs[0].data();
        this.runningSemester.ref = sem.docs[0].ref;
        this.runningSemester.id = sem.docs[0].id;
      }

      fb.db
        .collection("ContentTypes")
        .orderBy("index", "asc")
        .get()
        .then((querySnapshot) => {
          this.types = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
          });
        });

      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolDoc) => {
          if (schoolDoc.exists) {
            let school = schoolDoc.data();
            school.id = schoolDoc.id;
            this.school = school;

            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .onSnapshot((doc) => {
                let lesson = doc.data();
                lesson.id = doc.id;
                this.lesson = lesson;
                this.lesson.ref = doc.ref;
                this.countVideos();
              });
            fb.db
              .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
              .collection("topics")
              // .where("semester", "==", semesterDoc.ref)
              .orderBy("createdAt", "desc")
              .onSnapshot((querySnapshot) => {
                this.topics = [];
                querySnapshot.forEach((doc) => {
                  let object = doc.data();
                  object.id = doc.id;
                  object.details = [];
                  doc.ref
                    .collection("details")
                    .orderBy("createdAt")
                    .onSnapshot((contentSnapshot) => {
                      object.details = [];
                      contentSnapshot.forEach((contentDoc) => {
                        let content = contentDoc.data();
                        content.id = contentDoc.id;
                        content.uploading = false;
                        content.uploadPercent = 0;
                        object.details.push(content);
                      });
                    });
                  this.topics.push(object);
                });
              });
          }
        });
    },

    saveTopic() {
      if (
        this.lesson != null &&
        this.topic != null &&
        this.topic.name != "" &&
        this.topic.description != ""
      ) {
        if (this.topic.price != null && this.topic.price == "")
          this.topic.price = 0;

        this.topic.semester = this.runningSemester.ref;

        if (
          this.topic.id != null &&
          this.topic.id != "" &&
          this.topic.id != "new"
        ) {
          this.topic.modifiedAt = new Date();
          console.log(this.topic, this.runningSemester);
          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("topics")
            .doc(this.topic.id)
            .update(this.topic);
        } else {
          var now = new Date();
          this.topic.createdAt = now;

          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("topics")
            .doc()
            .set(this.topic)
            .then(() => {});
          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .update({
              numberOfTopics: fb.firestore.FieldValue.increment(1),
            });
        }
        this.topic = {
          name: null,
          description: null,
          price: 0,
          tags: [],
          shortname: null,
        };
        $("#exampleModal").modal("toggle");
      }
    },

    _editTopic(topic) {
      if (topic.semester) {
        this.semesters.forEach((value) => {
          if (value && value.path && value.path == topic.semester.path) {
            this.selectedSemester = value;
          }
        });
      }
      this.topic = Object.assign({}, topic);
      $("#exampleModal").modal("toggle");
    },
    uploadFile(topic, content) {
      var _this = this;
      var files = this.$refs["file_" + content.id][0].files;
      if (files != null && files.length > 0) {
        var file = files[0];
        if (
          file.name.endsWith("mp4") ||
          file.name.endsWith("MP4") ||
          file.name.endsWith("MPEG") ||
          file.name.endsWith("mov") ||
          file.name.endsWith("MOV") ||
          file.name.endsWith("webm") ||
          file.name.endsWith("WEBM")
        ) {
          alert("Та video файл оруулах боломжгүй");
          return;
        }
        var now = new Date();
        var fileName = this.topicBucket + now.getTime() + "_" + file.name;
        var uploadTask = fb.storageRef.child(fileName).put(file);
        content.uploading = true;
        content.uploadPercent = 0;
        uploadTask.on(
          fb.storage.TaskEvent.STATE_CHANGED,
          function (snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            content.uploadPercent = progress;
          },
          function (error) {
            switch (error.code) {
              case "storage/unauthorized":
                break;

              case "storage/canceled":
                break;
              case "storage/unknown":
                break;
            }
          },
          function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                let fileObject = {
                  fileName: fileName,
                  fileUrl: downloadURL,
                  realName: file.name,
                  uploadedAt: now,
                };
                fb.db
                  .doc(
                    "schools/" + this.schoolId + "/lessons/" + _this.lessonId
                  )
                  .collection("topics")
                  .doc(topic.id)
                  .collection("details")
                  .doc(content.id)
                  .update({
                    files: fb.firestore.FieldValue.arrayUnion(fileObject),
                  });
                content.uploading = false;
                content.uploadPercent = 0;
              });
          }
        );
      }
    },
    uploadFile1() {
      if (
        this.tmpAdditionalFile.name != null &&
        this.tmpAdditionalFile.name != ""
      ) {
        var _this = this;
        var files = this.$refs["lessonFile_" + this.lesson.id].files;

        if (files != null && files.length > 0) {
          var file = files[0];
          if (
            file.name.endsWith("mp4") ||
            file.name.endsWith("MP4") ||
            file.name.endsWith("MPEG") ||
            file.name.endsWith("mov") ||
            file.name.endsWith("MOV") ||
            file.name.endsWith("webm") ||
            file.name.endsWith("WEBM")
          ) {
            alert("Та video файл оруулах боломжгүй");
            return;
          }
          var now = new Date();
          var uploadTask = fb.storageRef
            .child(this.lessonBucket + now.getTime() + "_" + file.name)
            .put(file);
          _this.tmpAdditionalFile.uploading = true;
          _this.tmpAdditionalFile.uploadPercent = 0;
          uploadTask.on(
            fb.storage.TaskEvent.STATE_CHANGED,
            function (snapshot) {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              _this.tmpAdditionalFile.uploadPercent = progress;
            },
            function (error) {
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/unauthorized":
                  break;

                case "storage/canceled":
                  break;

                case "storage/unknown":
                  break;
              }
            },
            function () {
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  let fileObject = {
                    title: _this.tmpAdditionalFile.name,
                    fileName: file.name,
                    fileUrl: downloadURL,
                    uploadedAt: now,
                  };
                  fb.db
                    .doc(
                      "schools/" + this.schoolId + "/lessons/" + _this.lessonId
                    )
                    .update({
                      files: fb.firestore.FieldValue.arrayUnion(fileObject),
                    });

                  _this.tmpAdditionalFile = {
                    name: "",
                    uploading: false,
                    uploadPercent: null,
                  };
                  _this.$refs["lessonFile_" + _this.lesson.id].value = "";

                  if (!/safari/i.test(navigator.userAgent)) {
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "";
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "file";
                  }
                });
            }
          );
        }
      }
    },
    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { lessonId: this.lessonId, type: type.id, topicId: topic.id },
      });
    },

    _addTopic() {
      if (this.semesters) {
        this.semesters.forEach((value) => {
          if (value && value.default && value.default == true) {
            this.selectedSemester = value;
          }
        });
      }
      this.topic = {
        name: null,
        description: null,
        price: 0,
        tags: [],
      };
      $("#exampleModal").modal("toggle");
    },

    _deleteLessonFile(file, index) {
      var result = confirm("Та " + file.title + " файлыг устгах уу?");
      if (result) {
        var fileName = file.uploadedAt.toDate().getTime() + "_" + file.fileName;
        var fileRef = fb.storageRef.child(this.lessonBucket + fileName);
        // Delete the file
        fileRef
          .delete()
          .then(() => {
            this.lesson.files.splice(index, 1);
            fb.db
              .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
              .update({
                files: this.lesson.files,
              });
          })
          .catch(function (error) {});
      }
    },

    validFile(file) {
      if (
        file.fileName.endsWith("mp4") ||
        file.fileName.endsWith("MP4") ||
        file.fileName.endsWith("MPEG") ||
        file.fileName.endsWith("mov") ||
        file.fileName.endsWith("MOV") ||
        file.fileName.endsWith("webm") ||
        file.fileName.endsWith("WEBM")
      ) {
        return false;
      }
      return true;
    },
    getYoutubeId(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return "https://www.youtube.com/embed/" + id;
      }
      return null;
    },
    addTag(tag) {
      if (tag != null && tag != undefined) {
        if (this.topic.tags == null || this.topic.tags == undefined)
          this.topic.tags = [];
        if (!this.topic.tags.includes(tag)) {
          this.topic.tags.push(tag);
        }
        this.tagText = null;
      }
    },
    removeTag(tag, index) {
      if (tag != null && tag != undefined)
        if (this.topic.tags.includes(tag)) {
          this.topic.tags.splice(index, 1);
        }
    },
    async countVideos() {
      try {
        var batch = fb.db.batch();
        var videoCount = 0;
        var contentCount = 0;
        var querySnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .get();
        for (const doc of querySnapshot.docs) {
          if (doc.exists) {
            var contentSnapshot = await doc.ref.collection("details").get();
            contentSnapshot.forEach((contentDoc) => {
              if (
                contentDoc.exists &&
                contentDoc.data() &&
                contentDoc.data().videoUrl &&
                contentDoc.data().videoUrl != ""
              ) {
                videoCount++;
              }
              contentCount++;
            });
          }
        }
        batch.update(
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId),
          {
            numberOfTopics:
              querySnapshot && !querySnapshot.empty ? querySnapshot.size : 0,
            numberOfContent: contentCount,
            numberOfVideos: videoCount,
          }
        );
        await batch.commit();
      } catch (e) {}
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    Topics,
    LessonInfo,
  }, //README
  props: {
    lessonId: {
      required: true,
    },
    schoolId: {
      required: true,
    },
    sts: {
      required: false,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") this._setupp();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>

